/**
 * VueX module for interacting with Wizard related data
 */
export default {
    state: {
        newModel: {},
        editFieldData: {},
        showFieldEdit: false
    },

    getters: {
        newModel: state => state.newModel,
        editFieldData: state => state.editFieldData,
        showFieldEdit: state => state.showFieldEdit
    },

    mutations: {
        setNewModel(state, newModel) {
            state.newModel = newModel;
        },

        setShowFieldEdit(state, show) {
            state.showFieldEdit = show;
        },

        editFieldData(state, data) {
            state.editFieldData = data;
        }
    }
}